import styles from './ShowReservationWindow.module.scss';
import ModalWindow from '../ModalWindow';
import { useDispatch } from 'react-redux';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import { ModalWindowTypes } from '../../../utils/@globalTypes';
import BookingContainer from '../../Booking/BookingContainer';

const ShowReservationWindow = ({ data }: any) => {
  const dispatch = useDispatch();

  if (!data) {
    dispatch(setModalWindowData({ type: ModalWindowTypes.CLOSE }));
    return null;
  }

  return (
    <ModalWindow
      isLoading={false}
      isFullCustom
      hideCross
      windowClassname={styles.window}
    >
      <BookingContainer booking={data.booking} type={data.type} />
    </ModalWindow>
  );
};

export default ShowReservationWindow;
